/**
 * How long a signed attachment link lives, and when the web client refreshes one.
 *
 * A link minted before someone loses access to a thread must stop working within
 * about 5 minutes (docs/plans/2026-10-30-fix-sharing-u7-attachment-link-lifetime-plan.md).
 * Links the browser signs itself (task, draft and Messenger attachments) use it
 * directly; the edge functions `get-attachment-url` and `get-comment-attachment-url`
 * sign with their own SIGNED_URL_EXPIRY_SECONDS.
 */
export const ATTACHMENT_LINK_TTL_S = 300;

const ATTACHMENT_LINK_TTL_MS = ATTACHMENT_LINK_TTL_S * 1000;

/** Refreshed at half its life, so a link in the page always has time left when the browser asks again. */
export const ATTACHMENT_LINK_STALE_MS = ATTACHMENT_LINK_TTL_MS / 2;

/** Held one minute past expiry so a remount between refreshes reads the cache. */
export const ATTACHMENT_LINK_GC_MS = ATTACHMENT_LINK_TTL_MS + 60 * 1000;

/** A link this old is never handed to the browser: it could expire before the request lands. */
export const ATTACHMENT_LINK_RENDERABLE_MS = ATTACHMENT_LINK_TTL_MS - 60 * 1000;

export function isAttachmentLinkRenderable(mintedAt: number, now: number = Date.now()): boolean {
  return now - mintedAt < ATTACHMENT_LINK_RENDERABLE_MS;
}
